import moment, { MomentInput } from 'moment';

/**
 * The time part of a message row's accessible name. The day dividers are
 * not rows, so a screen reader moving between messages would otherwise hear
 * only times across a day boundary. A message from today gives its time,
 * an older one the date in the locale's format first. The visible time
 * column keeps showing the time alone.
 */
export const getMessageSentAriaLabel = (sent: string, now?: MomentInput) => {
    const sentAt = moment(sent);
    const time = sentAt.format('HH:mm');
    return sentAt.isSame(moment(now), 'day')
        ? time
        : `${sentAt.format('ll')}, ${time}`;
};
